export const TELEMETREE_PROJECT_ID = '42c13cb9-832d-4e22-9b45-a809cf843f79'
export const TELEMETREE_API_KEY = '02a9bcee-7c6f-471b-ae20-f2bc49ece9d0'
export const AMPLITUDE_API_KEY = '27bc7a32b0cc63d810804be42000b914'
